import { datadogRum } from "@datadog/browser-rum";
import { captureException } from "@sentry/react";
interface ErrorBody {
  error?: string;
}
export class ApiError extends Error {
  statusCode: number;
  body?: ErrorBody;

  constructor(message: string, statusCode: number, body?: ErrorBody) {
    super(message);
    this.statusCode = statusCode;
    this.body = body;
  }
}

export const checkStatus = async (res: Response): Promise<Response> => {
  if (res.status >= 200 && res.status < 300) {
    return res;
  } else {
    const errorText = `Unable to fetch ${res.url} successfully. Got ${res.status} - ${res.statusText}`;
    // Using a console log here to avoid duplicate error reports with sentry and datadog
    // The css makes it look like a console error
    // Adding nosem here to ignore the no-console logs error
    // nosemgrep
    console.log(
      `%c ${String.fromCodePoint(0x1f6ab)} ${errorText}`,
      "color: #ff8080; background: hsl(0deg 100% 8%);"
    );
    // let's try to get more context from the backend
    let backendApiError = { error: errorText }; // fallback
    try {
      backendApiError = await res.json();
    } catch (e) {
      // handle case where API is down and bad gateway from the load balancer isn't json
      console.error("unable to process error from backend", e);
    }
    const err = new ApiError(errorText, res.status, backendApiError);
    datadogRum.addError(err, {
      url: res.url,
      statusCode: err.statusCode,
    });
    captureException(err);
    throw err;
  }
};
